import script from "./Contracts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Contracts.vue?vue&type=script&setup=true&lang=ts"

import "./Contracts.vue?vue&type=style&index=0&id=bc75e75a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc75e75a"]])

export default __exports__